<template>
  <div class="app-bar">
    <div
      class="icon-item back iconfont icon-fanhui2"
      :style="{ top: statusBarHeight + 'px' }"
      @click="bindBack"
    ></div>
    <div
      class="icon-item share iconfont icon-fenxiang"
      :style="{ top: statusBarHeight + 'px' }"
      @click="bindShare"
    ></div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      statusBarHeight: 10
    }
  },
  created() {
    this.getStatusBarHeight()
  },
  methods: {
    async getStatusBarHeight() {
      let res = await this.$betterwe.getAppBarHeight()
      if (res) {
        this.statusBarHeight = res.statusBarHeight + 10
      }
    },
    bindShare() {
      this.$emit('share')
    },
    bindBack() {
      this.$http.appBack()
    }
  }
}
</script>
<style lang="scss" scoped>
.app-bar {
  position: fixed;
  left: 0;
  width: 100%;
  top: 0;
  z-index: 1;

  .icon-item {
    position: fixed;
    z-index: 1;
    color: #fff;
    width: 28px;
    height: 28px;
    background: rgba(0, 0, 0, 0.29);
    backdrop-filter: blur(10px);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
  .back {
    left: 10px;
    top: 10px;
  }
  .share {
    right: 10px;
    top: 10px;
  }
}
</style>
